import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { server_connection } from 'config';
import ReactDropzone from 'react-dropzone';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import {Snackbar, IconButton, Icon} from '@material-ui/core';

import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';

class AssetUpload extends Component {

    state = { files: [], wrongFormatError: false, fileSizeError: false }

    stopEvent = (ev) => {
        ev.stopPropagation()
    }

    checkAccepted = (file) => {
        // this had to be broken out for the ReactDropzone package because it would leave some filetypes as blank
        const accepted = [
            'jpg', 'jpeg', 'png', 'svg', 'gif', 'tiff', 'bmp',
            'mp4', 'mp3', 'mov', 'avi', 'wmv',
            'pdf', 'txt', 'rtf', 'csv', ,'doc', 'docx',
            'xls', 'xlsx', 'ppt', 'pptx', 'odp'
        ]

        const filesplit = file.split('.');
        const filetype = filesplit[filesplit.length - 1];

        if (accepted.includes(filetype.toLowerCase())) {
            return true
        }
        return false
    }

    handleDrop = (files) => {
        this.setState({ wrongFormatError: false, fileSizeError: false })
        const data = new FormData();
        files.forEach(file => {
            if (this.checkAccepted(file.name)) {
                data.append('assetFile', file);
            }
            else {
                this.setState({ wrongFormatError: true })
            }
        });

        // this is for the rel in the asset table. ie 'Assignment File'
        data.append('fileType', this.props.file_type)

        if (files.length > 1) {
            data.append('multiple_files', true)
        }
        else {
            data.append('multiple_files', false)
        }

        return this.onDrop(data)
    }

    onDrop = (data) => {
        if (this.props.requires_relation) {
            data.append('auth_id', this.props.auth_id);
            data.append('modelType', this.props.modelType);
            data.append('model_id', this.props.model_id);
            this.props.uploadAssetWithRelation(data, this.props.modelType, this.props.model_id, this.props.getAssetList);
        } else {
            const auth_id = this.props.auth_id ? this.props.auth_id : this.props.auth.user.data.auth_id;
            data.append('auth_id', auth_id);
            this.props.uploadAssetNoRelation(data, this.props.modelType, this.props.model_id, this.props.responseFunction);
        }
        return false
    }

    render() {

        const maxSize = this.props.file_type === 'User Note' ? 1048576 * 15 : 1048576 * 100;
        const maxSizeDisplay = this.props.file_type === 'User Note' ? '15MB': '100MB'

        return (
            <ReactDropzone
                onDrop={this.handleDrop}
                // 15 MB
                maxSize={maxSize}
                onDropRejected={() => this.setState({ fileSizeError: true })}
            >
                {this.props.displayText || <div style={{ textAlign: 'center' }}>Drag files here {maxSizeDisplay} Max</div>}
                {this.state.wrongFormatError ? <div style={{ backgroundColor: 'red', color: 'white', float: 'bottom', textAlign: 'center' }} >File type(s) not supported</div> : null}
                {this.state.fileSizeError ? <div style={{ backgroundColor: 'red', color: 'white', float: 'bottom', textAlign: 'center' }} >File size too large</div> : null}
            </ReactDropzone>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        uploadAssetWithRelation: Actions.uploadAssetWithRelation,
        uploadAssetNoRelation: Actions.uploadAssetNoRelation
    }, dispatch);
}


function mapStateToProps({ auth }) {
    return {
        auth
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetUpload)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetUpload.js